import { css } from '@emotion/react';

const idleFeeBlockStyles = {
    block: css({
        padding: '10px 15px',
        border: '1px solid #FCE03E',
        borderRadius: '8px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '12px',
        backgroundColor: '#FCE03E1F',
        width: '100%',
    }),
    icon: css({
        width: 24,
        height: 24,
        flex: '0 0 auto',
    }),
    content: css({
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        flex: 1,
        minWidth: 0,
    }),
    titleRow: css({
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        gap: 8,
        width: '100%',
    }),
    title: css({
        fontSize: 13,
        lineHeight: '16px',
        fontWeight: 700,
        color: '#000000',
        whiteSpace: 'pre-wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }),
    subtitle: css({
        fontSize: 12,
        lineHeight: '14px',
        fontWeight: 400,
        color: '#00000099',
    }),
}

export default idleFeeBlockStyles;